import { render, staticRenderFns } from "./section-reviewable-list.vue?vue&type=template&id=0180989f&"
import script from "./section-reviewable-list.vue?vue&type=script&lang=js&"
export * from "./section-reviewable-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports